import React from 'react';
import { ContentCenter } from './ContentCenter';

import { LibraryType } from './ContentCenter.types';

export const ImageLibrary: React.FC = () => <ContentCenter libraryType={'imageLibrary' as LibraryType} />;
